/* Product-aware FAQ navigation. All content remains in the server-rendered document. */
if (!customElements.get('badema-faq-hub')) {
  customElements.define('badema-faq-hub', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.setup()); }
    setup() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.panels = [...this.querySelectorAll('[data-faq-panel]')];
      this.links = [...this.querySelectorAll('[data-panel]')];
      this.input = this.querySelector('[data-search]');
      this.picker = this.querySelector('[data-picker]');
      this.clearButton = this.querySelector('[data-clear]');
      this.status = this.querySelector('[data-status]');
      this.empty = this.querySelector('[data-empty]');
      if (!this.panels.length || !this.input || !this.picker) return;
      this.active = this.dataset.storeId;
      this.rows = this.panels.map(panel => ({
        panel,
        title: panel.querySelector('h2')?.textContent.trim() || '',
        questions: [...panel.querySelectorAll('[data-question]')].map(element => ({element, text: this.normalize(element.textContent)}))
      }));
      this.querySelector('[data-tools]').hidden = false;
      this.classList.add('bfq--enhanced');
      const nav = this.querySelector('[data-nav]');
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-orientation', 'vertical');
      this.links.forEach(link => {
        link.setAttribute('role', 'tab');
        link.setAttribute('aria-controls', link.dataset.panel);
        link.addEventListener('click', event => { event.preventDefault(); this.activate(link.dataset.panel, true); }, {signal});
        link.addEventListener('keydown', event => {
          const index = this.links.indexOf(link);
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % this.links.length;
          if (event.key === 'ArrowUp') next = (index - 1 + this.links.length) % this.links.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.links.length - 1;
          if (next !== undefined) { event.preventDefault(); this.activate(this.links[next].dataset.panel, false); this.links[next].focus(); }
        }, {signal});
      });
      this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      this.picker.addEventListener('change', () => this.activate(this.picker.value, true), {signal});
      this.input.addEventListener('input', () => this.filter(), {signal});
      this.input.addEventListener('keydown', event => { if (event.key === 'Escape' && this.input.value) { event.preventDefault(); this.activate(this.active, false); } }, {signal});
      this.clearButton.addEventListener('click', () => { this.activate(this.active, false); this.input.focus(); }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-faq-panel]');
        if (panel) this.activate(panel.id, false);
      }, {signal});
      let initialTarget;
      try { initialTarget = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (_) {}
      const initialPanel = this.panels.find(panel => panel === initialTarget || (initialTarget && panel.contains(initialTarget)));
      this.activate(initialPanel?.id || this.active, false);
      if (initialTarget?.matches('[data-question]')) initialTarget.open = true;
    }
    normalize(value) {
      return String(value || '').toLocaleLowerCase('tr').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/\s+/g, ' ').trim();
    }
    activate(id, updateHash) {
      const activeRow = this.rows.find(row => row.panel.id === id);
      if (!activeRow) return;
      this.active = id;
      this.input.value = '';
      this.clearButton.hidden = true;
      this.empty.hidden = true;
      this.picker.value = id;
      this.rows.forEach(row => {
        row.panel.hidden = row.panel.id !== id;
        row.questions.forEach(question => question.element.hidden = false);
        row.panel.querySelectorAll('[data-question-group]').forEach(group => group.hidden = false);
      });
      this.links.forEach(link => {
        const selected = link.dataset.panel === id;
        link.setAttribute('aria-selected', String(selected));
        link.tabIndex = selected ? 0 : -1;
      });
      this.status.textContent = `${activeRow.title} · ${activeRow.questions.length} soru`;
      if (updateHash) history.replaceState(history.state, '', `#${id}`);
    }
    filter() {
      const query = this.normalize(this.input.value);
      if (!query) { this.activate(this.active, false); return; }
      let matches = 0, groups = 0;
      this.clearButton.hidden = false;
      this.links.forEach(link => { link.setAttribute('aria-selected', 'false'); link.tabIndex = link.dataset.panel === this.active ? 0 : -1; });
      this.rows.forEach(row => {
        const titleMatches = this.normalize(row.title).includes(query);
        let count = 0;
        row.questions.forEach(question => {
          const visible = titleMatches || question.text.includes(query);
          question.element.hidden = !visible;
          if (visible) count++;
        });
        row.panel.hidden = count === 0;
        row.panel.querySelectorAll('[data-question-group]').forEach(group => group.hidden = ![...group.querySelectorAll('[data-question]')].some(question => !question.hidden));
        if (count) groups++;
        matches += count;
      });
      this.empty.hidden = matches !== 0;
      this.status.textContent = matches ? `${matches} soru bulundu · ${groups} başlık` : 'Aramayla eşleşen soru bulunamadı.';
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.controller = null; }
  });
}
